module.exports = __webpack_public_path__ + "img/img2.a3ce1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/img2.jpg
// module id = 347
// module chunks = 0